import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudSubnet = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'subnet/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllSubnet = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_subnet_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudSubnet = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'subnet/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudSubnet = (data, id) => {
  let url = privateCloudBaseUrl + 'subnet/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    needPrivateCloudProjectHeader: true,
    method: method
  })
}

export const deletePrivateCloudSubnet = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'subnet/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
